import e from "react";
import { css as t, styled as n } from "styled-components";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-progress";
//#region src/components/ProgressBar/ProgressBar.tsx
var o = {
	sm: t`
        height: 4px;
    `,
	md: t`
        height: 8px;
    `,
	lg: t`
        height: 12px;
    `
}, s = {
	default: t`
        background-color: ${({ theme: e }) => e.colors.primary};
    `,
	success: t`
        background-color: ${({ theme: e }) => e.colors.success};
    `,
	warning: t`
        background-color: ${({ theme: e }) => e.colors.warning};
    `,
	destructive: t`
        background-color: ${({ theme: e }) => e.colors.destructive};
    `,
	muted: t`
        background-color: ${({ theme: e }) => e.colors.foreground};
    `
}, c = n.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(3)};
    width: 100%;
`, l = n(a.Root)`
    position: relative;
    overflow: hidden;
    background-color: ${({ theme: e }) => e.colors.muted};
    border-radius: ${({ theme: e }) => e.radii.full};
    width: 100%;
    /* Fix weird clipping issues in Safari */
    transform: translateZ(0);

    ${({ $size: e }) => o[e]}
`, u = n(a.Indicator)`
    width: 100%;
    height: 100%;
    transition: transform 660ms cubic-bezier(0.65, 0, 0.35, 1);
    transform: translateX(-${({ $progress: e }) => 100 - e}%);
    border-radius: ${({ theme: e }) => e.radii.full};

    ${({ $variant: e }) => s[e]}
`, d = n.span`
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    min-width: 40px;
    text-align: right;
`, f = e.forwardRef(({ value: e = 0, max: t = 100, size: n = "md", variant: a = "default", showLabel: o = !1, className: s, ...f }, p) => {
	let m = Math.min(Math.max(e, 0), t), h = m / t * 100;
	return /* @__PURE__ */ i(c, {
		className: s,
		children: [/* @__PURE__ */ r(l, {
			ref: p,
			$size: n,
			value: m,
			max: t,
			...f,
			children: /* @__PURE__ */ r(u, {
				$variant: a,
				$progress: h
			})
		}), o && /* @__PURE__ */ i(d, { children: [Math.round(h), "%"] })]
	});
});
f.displayName = "ProgressBar";
//#endregion
export { f as ProgressBar };
